/**
 * 默认文件夹路径
 */
export const DEFAULT_IMAGE_FOLDER_PATH = 'eureka-ip/novelty-check/images';

/**
 * 默认文件名前缀
 */
export const DEFAULT_IMAGE_FILE_PREFIX = 'novelty_image';
